import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@material-ui/core";
import * as React from "react";
import { BooleanInput, Button, required, TextInput, useNotify } from "react-admin";
import { Form } from "react-final-form";
import appDataProvider from "../../../dataprovider";

const ReliabilityManualRogueCreate = ({ isOpen, onClose, reportType, ...rest }) => {
  const { http } = appDataProvider;
  const [loading, setLoading] = React.useState(false);
  var notify = useNotify();

  const handleClose = () => {
    setLoading(false);
    onClose?.();
  };
  const handleSubmit = values => {
    create(values);
    setLoading(true);
  };

  const create = values => {
    http
      .post("reliabilityreports/manualroguecreate", { ...values })
      .then(result => {
        if (result?.data !== undefined && result?.data !== null) {
          notify(`Successfully completed`, "success", false, true);
          handleClose();
        } else {
          notify("Operation failed. Please try again.", "error", false, true);
          handleClose();
        }
      })
  };

  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={{ type: 1, reportType: reportType }}
      render={({ handleSubmit, values, invalid }) => (
        <form onSubmit={handleSubmit} noValidate>
          <Dialog open={isOpen} fullWidth={true} maxWidth={"xs"} onClose={handleClose}>
            <DialogTitle id="confirmation-dialog-title">{"Create Rogue Candidate"}</DialogTitle>
            <DialogContent dividers>
              <Grid container>
                <Grid item xs={12}>
                  <TextInput
                    source="goodsrcvdbatch"
                    label="Goods Rcvd Batch"
                    fullWidth
                    validate={required()}
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12}>
                  <BooleanInput label="Is Five Consecutive Avg" source="isfiveconsecutiveavg" defaultValue={false} />
                </Grid>
                <Grid item xs={12}>
                  <BooleanInput label="Is Three Consecutive" source="isthreeconsecutive" defaultValue={false} />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button variant="contained" label="Close" onClick={handleClose} disabled={loading} color="default" />
              <Button
                variant="contained"
                label="Submit"
                type="submit"
                onClick={handleSubmit}
                disabled={loading || invalid}
                color="primary"
              />
            </DialogActions>
          </Dialog>
        </form>
      )}
    />
  );
};

export default ReliabilityManualRogueCreate;
